/**
 * Domain output renderers (UI-SPEC §8). A registry (mirrors registerEntityKind)
 * so VerdictCard/RunTrace render a workflow's output legibly per domain — a support
 * routing decision as a labeled chip, a code change as a diff/pre, an email as
 * an email — while the engine stays domain-agnostic.
 */

import * as React from "react";
import { IntentBadge } from "../status-badge";

export type DomainOutputRenderer = (text: string) => React.ReactNode;

function preRender(text: string): React.ReactNode {
  return (
    <pre className="max-h-56 overflow-auto whitespace-pre-wrap break-words rounded bg-selected px-2 py-1 type-subtext text-foreground">
      {text || "(no output)"}
    </pre>
  );
}

// support: surface the routed category as a chip if present.
const CATEGORY = /\b(Billing|Bug|HowTo|Account|Refund|Other)\b/;
function supportRender(text: string): React.ReactNode {
  const m = CATEGORY.exec(text);
  return (
    <div className="flex flex-col gap-1">
      {m && <IntentBadge intent="info">routed: {m[1]}</IntentBadge>}
      {preRender(text)}
    </div>
  );
}

const REGISTRY: Record<string, DomainOutputRenderer> = {
  support: supportRender,
  code: preRender,
};

export function renderDomainOutput(domain: string | null | undefined, text: string): React.ReactNode {
  const r = (domain && REGISTRY[domain]) || preRender;
  return r(text);
}

export function registerDomainRenderer(domain: string, renderer: DomainOutputRenderer): void {
  REGISTRY[domain] = renderer;
}
